<template>
  <div class="responsive_wrapper">
    <div class="note_text mt-15">
      Indicate if you would like to receive notifications via email or as notifications in the
      application when you are mentioned in a project/comment
    </div>
    <div class="mr-tb-15">
      <div class="row_wrapper row">
        <div class="col-md-6 col-sm-6 col-xs-12">Type</div>
        <div class="col-md-3 col-sm-3 hide_xs in_app_label header_label_text">
          In-app Notification
        </div>
        <div class="col-md-3 col-sm-3 hide_xs header_label_text email-left">Email</div>
      </div>
      <div class="row_wrapper row">
        <div class="col-md-6 col-sm-6 col-xs-12">
          <label class="alert_text">Notifications</label>
        </div>
        <div class="toggle_switch in_app_label col-md-3 col-sm-3 col-xs-7">
          <small class="display_xs">In-app Notification</small>
          <label class="switch">
            <input
              type="checkbox"
              v-model="smartBuilderInAppPreference"
              @change="$emit('update:sb_in_app_preference', $event.target.checked)"
            />
            <span class="slider round"></span>
          </label>
          <span v-if="smartBuilderInAppPreference" class="switch_label">On</span>
          <span v-else class="switch_label switch_off">Off</span>
        </div>
        <div class="toggle_switch col-md-3 col-sm-3 col-xs-4">
          <small class="display_xs">Email</small>
          <label class="switch email-switch">
            <input
              type="checkbox"
              v-model="smartBuilderEMailPreference"
              @change="$emit('update:sb_email_preference', $event.target.checked)"
            />
            <span class="slider round"></span>
          </label>
          <span v-if="smartBuilderEMailPreference" class="switch_label">On</span>
          <span v-else class="switch_label switch_off">Off</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['sb_email_preference', 'sb_in_app_preference'],
  data() {
    return {
      smartBuilderEMailPreference: true,
      smartBuilderInAppPreference: true
    };
  },
  watch: {
    sb_email_preference() {
      this.smartBuilderEMailPreference = this.sb_email_preference;
    },
    sb_in_app_preference() {
      this.smartBuilderInAppPreference = this.sb_in_app_preference;
    }
  }
};
</script>
<style lang="scss" scoped>
.note_text {
  margin-top: 15px;
  margin-bottom: 15px;
  font-family: Roboto;
  font-style: normal;
  @include fontItems($font-14, 16px, $font-weight-normal !important);
  color: $dark-black-alpha;
}
.mr-tb-15 {
  margin: 15px 0px !important;
}
.row_wrapper {
  padding-top: 8px;
  padding-bottom: 8px;
  border-bottom: 0.5px solid $gray74;
}
.header_label_text {
  @include fontItems($font-16, 19px, $font-weight-medium);
  color: $dark-black-alpha;
}
.alert_text {
  font-family: Roboto;
  font-style: normal;
  @include fontItems($font-14, 16px, $font-weight-normal !important);
  vertical-align: bottom;
  color: $dark-black-alpha !important;
  margin-bottom: 0px;
}
.toggle_switch {
  margin-top: 5px;
}
.display_xs {
  display: none;
}
.email-left {
  left: 23px;
}

.email-switch {
  margin-left: 25px;
}
input[type='checkbox'] {
  opacity: 0;
  position: absolute;
  z-index: 1;
  width: 18px !important;
  height: 18px !important;
  left: 0;
  top: 0;
  margin: 0 !important;
}
.radio label {
  cursor: none;
}

@media (min-width: 768px) and (max-width: 850px) {
  .in_app_label {
    padding: 0px;
  }
}
@media screen and (max-width: 767px) {
  .hide_xs {
    display: none;
  }
  .display_xs {
    display: block;
  }
  .xs-mr-tp-5 {
    margin-top: 5px;
  }
  .switch {
    &.email-switch {
      left: 0;
      margin-left: 0px;
    }
  }
}
@media screen and (max-width: 400px) {
  .responsive_wrapper {
    height: 53vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
